import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/app/privacy/page.tsx")